import {openModal} from '../../ui/index.js'

export const MODAL_NAME = 'LIST_ON_AMAZON_MODAL'

export function showListOnAmazonModal(skus) {
  return openModal(MODAL_NAME, {skus})
}
